export default {
  white: '#ffffff',
  mediumBlue: '#3c5aa3',
  darkBlue: '#062253',
  almostBlack: '#242424',
  darkGrey: '#53565a',
  grey: '#BDC2CB',
  black: '#000000',
  offWhite: '#F2F9F7',
  darkBlueAlt: '#b7caf0',
  linkHover: '#3c5aa3'
}
